import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n
// load translation using http -> see /public/locales
// (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
// learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
// pass the i18n instance to react-i18next.
    .use(initReactI18next)
// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: 'en-US',
        fallbackLng: 'en-US',
        // allow keys to be phrases having `:`, `.`
        nsSeparator: false,
        ns: ['enums'],
        keySeparator: false,
        load: 'languageOnly',
        debug: process.env.REACT_APP_HOST_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;